import React from "react";
import YouTube from "react-youtube";
import * as ls from "../../lib/localStorage";
import { fetchPlayCount } from "@Services/api";
import SeriesPlay from "./SeriesPlay";
import { g4 } from "../../utils/helper";

class YoutubeVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show_next_movie: false,
      next_data: "",
      auto_status: true,
    };
    this.playStatus = false;
    this.play = true;
    this.event;
    this.off_on = true;
    this.next_auto_play;
    this.record_data = {};
    this.handleScroll = this.handleScroll.bind(this);
  }
  componentDidMount() {
    let self = this;
    this.playRecordFind();
    window.addEventListener("scroll", this.handleScroll);
    window.onbeforeunload = function (e) {
      self.lsgRecord();
    };
  }
  handleScroll(e) {
    let scrollTop = document.documentElement.scrollTop;

    if (scrollTop >= 800 && this.off_on) {
      this.setState({
        auto_status: false,
      });
      this.off_on = false;
    } else if (scrollTop <= 800 && this.off_on == false) {
      this.setState({
        auto_status: true,
      });
      this.off_on = true;
    }
  }
  componentWillUnmount() {
    this.lsgRecord();
    window.onbeforeunload = null;
    window.removeEventListener("scroll", this.handleScroll);
  }
  lsgRecord() {
    let data = this.getItemData(),
      index = this.record_data.index,
      arr = [],
      ls_record_data = ls.read("movieData", "json") || [];

    if (!this.playStatus) return false;

    if (index != undefined) {
      ls_record_data.map((v, i) => {
        if (i != index) {
          arr.push(v);
        }
      });
      ls_record_data = arr;
      data.currentTime = data.ratio >= 90 ? 0 : data.currentTime;
    }

    ls_record_data.push(data);
    ls.write("once_data", data);
    ls.write("movieData", ls_record_data);
  }
  getItemData() {
    const { data } = this.props;
    try {
      this.event;
      let event = this.event,
        currentTime = parseInt(event.target.j.currentTime),
        duration = parseInt(event.target.j.duration),
        ratio = parseInt((currentTime / duration) * 100),
        movie_id = data.id,
        img_url = data.img_url || data.thumb,
        title = data.title,
        play_num_total = data.play_num_total || 0,
        item_data = {
          currentTime: currentTime,
          duration: duration,
          ratio: ratio,
          id: movie_id,
          img_url: img_url,
          title: title,
          play_num_total: play_num_total,
        };

      return item_data;
    } catch (e) {
      return false;
    }
  }
  // 查看是否存在看過記錄
  playRecordFind() {
    const { data } = this.props;

    let movieData = ls.read("movieData", "json") || [],
      movie_id = data.id;

    movieData.find((value, index, arr) => {
      if (value.id == movie_id) {
        this.record_data = { index: index, value: value, arr: arr };
      }
    });
  }
  playVideo() {
    const { data, onChildClick } = this.props;

    let event = this.event;

    try {
      onChildClick && onChildClick(event.target);
      event.target.playVideo();
      g4("video_played", {
        page: "影音詳情頁",
        element: "影音",
        element_id: data.movieId || data.id,
      });
    } catch (e) {
      console.log("未開始");
    }
  }
  //記錄播放數
  playVideoCount() {
    if (this.playStatus) {
      return false;
    }
    this.playStatus = true;

    const { data } = this.props;

    let params = {
      value: 1,
      os: "pc",
      device_id: ls.read("uuid"),
      category: "movie",
      action: "play",
      label: data.id,
    };

    fetchPlayCount(params);
  }
  _test() {
    let event = this.event;
    event.target.seekTo(event.target.j.duration - 2);
  }
  _onReady(event) {
    this.event = event;
  }
  _onPause(event) {
    window.postMessage("pause", "*");
    console.log("_onPause");
  }
  _onPlay(event) {
    window.postMessage("play", "*");

    if (this.record_data.value && this.play && this.record_data.value.ratio < 90) {
      event.target.seekTo(this.record_data.value.currentTime);
      this.play = false;
    }

    this.playVideo();
    this.playVideoCount();
  }
  //播放結束啟動
  _onEnd() {
    const { onEnd } = this.props;

    onEnd && onEnd();
  }

  refresh() {
    const { data, dispatch } = this.props;
    let event = this.event,
      title = data.title;

    dispatch({ type: "movie/showNext" });
    event.target.playVideo();
    // logEvent("影音詳細頁", "重新播放", title);
    this.cannelNext(true);
  }

  render() {
    const { data, dispatch, show_next, movie_relate, style, videoId } = this.props;
    let opts = {
      width: "100%",
      height: "100%",
      playerVars: {
        controls: 2,
        playsinline: 1,
        rel: 0,
        modestbranding: 1,
        showinfo: 0,
      },
    };

    return (
      <>
        <section className='video-section' style={style}>
          {videoId != "" ? (
            <YouTube
              videoId={videoId}
              opts={opts}
              onReady={(e) => this._onReady(e)}
              onPlay={(e) => this._onPlay(e)}
              onPause={this._onPause}
              onEnd={() => this._onEnd()}
              onError={this._onError}
              onStateChange={this._onStateChange}
              onPlaybackRateChange={this._onPlaybackRateChange}
              onPlaybackQualityChange={this._onPlaybackQualityChange}
            />
          ) : (
            <iframe className={"fb-iframe"} src={data.ytLink}></iframe>
          )}
          {show_next && movie_relate != "" && this.state.auto_status && (
            <SeriesPlay data={movie_relate} img_url={data.thumb} dispatch={dispatch} refresh={() => this.refresh()} />
          )}
        </section>
      </>
    );
  }
}

export default YoutubeVideo;
